module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pendencyBody"
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n                ")], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.name))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User Filter")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "addedUserFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "userFilter", $$v)
      },
      expression: "Filter.userFilter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(!_vm.isLoading) ? _c('small', [_vm._v(_vm._s(_vm.JOBList.length) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [(_vm.JOBList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName !== 'Export As Excel',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.ExcelBtnName) + "\n                        "), (_vm.ExcelBtnName !== 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.JOBList.length,
      "per-page": _vm.paginationItem.perPage
    },
    model: {
      value: (_vm.paginationItem.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.paginationItem, "currentPage", $$v)
      },
      expression: "paginationItem.currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row table-wrapper-scroll-x my-custom-scrollbar"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnMain,
      "items": _vm.JOBList,
      "per-page": _vm.paginationItem.perPage,
      "current-page": _vm.paginationItem.currentPage,
      "filter": _vm.filter
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                            " + _vm._s(row0.index + 1) + "\n                        ")]), _vm._v(" "), _c('b-button', {
          staticClass: "ml-1",
          staticStyle: {
            "margin-left": "auto",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row0.item, 2)
            }
          }
        }, [_vm._v("\n                            Update\n                        ")]), _vm._v(" "), (row0.item.preq_client_log.length > 0) ? _c('b-button', {
          staticClass: "ml-1",
          staticStyle: {
            "margin-left": "auto",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row0.item, 1)
            }
          }
        }, [_vm._v("\n                            Show Log\n                        ")]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "UpdateCBModal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "title": 'Update Information : ' + _vm.updateItem.JobNo,
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeModal
    }
  }, [(_vm.modalType == 1) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnLogMain,
      "items": _vm.LogList
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                                " + _vm._s(row0.index + 1) + "\n                            ")])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.modalType == 2) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: !_vm.updateItem.fk_shipper_id && _vm.errorUpdate.fk_shipper_id ? 'red' : '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "shipper_id",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Shipper Name"
    },
    model: {
      value: (_vm.updateItem.fk_shipper_id),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "fk_shipper_id", $$v)
      },
      expression: "updateItem.fk_shipper_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "actual-vessel-name"
    }
  }, [_vm._v("Actual Vessel Name")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.actual_vessel_name && _vm.errorUpdate.actual_vessel_name ? 'red' : '',
    }),
    attrs: {
      "id": "actual-vessel-name",
      "type": "text"
    },
    model: {
      value: (_vm.updateItem.actual_vessel_name),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "actual_vessel_name", $$v)
      },
      expression: "updateItem.actual_vessel_name"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.actual_vessel_name))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "po-number"
    }
  }, [_vm._v("PO Number "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.po_number && _vm.errorUpdate.po_number ? 'red' : '',
    }),
    attrs: {
      "id": "po-number",
      "type": "text"
    },
    model: {
      value: (_vm.updateItem.po_number),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "po_number", $$v)
      },
      expression: "updateItem.po_number"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.po_number))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "cargo-estimated-readiness-date"
    }
  }, [_vm._v("Cargo Estimated Readiness Date")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.cargo_estimated_readiness_date && _vm.errorUpdate.cargo_estimated_readiness_date ? 'red' : '',
    }),
    attrs: {
      "id": "cargo-estimated-readiness-date",
      "type": "date"
    },
    model: {
      value: (_vm.updateItem.cargo_estimated_readiness_date),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "cargo_estimated_readiness_date", $$v)
      },
      expression: "updateItem.cargo_estimated_readiness_date"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.cargo_estimated_readiness_date))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "estimated-arrival-at-port-date"
    }
  }, [_vm._v("Estimated Arrival at Port Date")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.estimated_arrival_at_port_date && _vm.errorUpdate.estimated_arrival_at_port_date ? 'red' : '',
    }),
    attrs: {
      "id": "estimated-arrival-at-port-date",
      "type": "date"
    },
    model: {
      value: (_vm.updateItem.estimated_arrival_at_port_date),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "estimated_arrival_at_port_date", $$v)
      },
      expression: "updateItem.estimated_arrival_at_port_date"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.estimated_arrival_at_port_date))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "tentative-date-sale"
    }
  }, [_vm._v("Tentative Date Sail")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.tentative_date_sale && _vm.errorUpdate.tentative_date_sale ? 'red' : '',
    }),
    attrs: {
      "id": "tentative-date-sale",
      "type": "date"
    },
    model: {
      value: (_vm.updateItem.tentative_date_sale),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "tentative_date_sale", $$v)
      },
      expression: "updateItem.tentative_date_sale"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.tentative_date_sale))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "cargo-arrival-at-port"
    }
  }, [_vm._v("Cargo Arrival at Port")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.cargo_arrival_at_port && _vm.errorUpdate.cargo_arrival_at_port ? 'red' : '',
    }),
    attrs: {
      "id": "cargo-arrival-at-port",
      "type": "date"
    },
    model: {
      value: (_vm.updateItem.cargo_arrival_at_port),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "cargo_arrival_at_port", $$v)
      },
      expression: "updateItem.cargo_arrival_at_port"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.cargo_arrival_at_port))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "estimated-arrival-at-pod-date"
    }
  }, [_vm._v("Estimated Arrival at POD Date")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.estimated_arrival_at_pod_date && _vm.errorUpdate.estimated_arrival_at_pod_date ? 'red' : '',
    }),
    attrs: {
      "id": "estimated-arrival-at-pod-date",
      "type": "date"
    },
    model: {
      value: (_vm.updateItem.estimated_arrival_at_pod_date),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "estimated_arrival_at_pod_date", $$v)
      },
      expression: "updateItem.estimated_arrival_at_pod_date"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.estimated_arrival_at_pod_date))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "actual-arrival-at-pod-date"
    }
  }, [_vm._v("Actual Arrival at POD Date")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.actual_arrival_at_pod_date && _vm.errorUpdate.actual_arrival_at_pod_date ? 'red' : '',
    }),
    attrs: {
      "id": "actual-arrival-at-pod-date",
      "type": "date"
    },
    model: {
      value: (_vm.updateItem.actual_arrival_at_pod_date),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "actual_arrival_at_pod_date", $$v)
      },
      expression: "updateItem.actual_arrival_at_pod_date"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.actual_arrival_at_pod_date))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "actual-arrival-at-fpod-date"
    }
  }, [_vm._v("Actual Arrival at FPOD Date")]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor: !_vm.updateItem.actual_arrival_at_fpod_date && _vm.errorUpdate.actual_arrival_at_fpod_date ? 'red' : '',
    }),
    attrs: {
      "id": "actual-arrival-at-fpod-date",
      "type": "date"
    },
    model: {
      value: (_vm.updateItem.actual_arrival_at_fpod_date),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "actual_arrival_at_fpod_date", $$v)
      },
      expression: "updateItem.actual_arrival_at_fpod_date"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.actual_arrival_at_fpod_date))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "remarks"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-textarea', {
    style: ({
      borderColor: !_vm.updateItem.remarks && _vm.errorUpdate.remarks ? 'red' : '',
    }),
    attrs: {
      "rows": "3",
      "id": "remarks",
      "type": "text"
    },
    model: {
      value: (_vm.updateItem.remarks),
      callback: function($$v) {
        _vm.$set(_vm.updateItem, "remarks", $$v)
      },
      expression: "updateItem.remarks"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorUpdate.remarks))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-end"
  }, [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.updateAgentCms
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e128a3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/agentDash/agentCmsConsoleDash.vue
// module id = 2432
// module chunks = 0